import { createAsyncThunk, createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { Template } from "../../lib/interfaces/Template";
import { LoadingStatusCode } from "../../lib/types/LoadingStatusCode";
import requestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { getTemplatesRoute } from "../../lib/routes/templates";

interface InitialState {
  templates: Template[];
  templatesLoading: LoadingStatusCode;
}

const initialState: InitialState = {
  templates: [],
  templatesLoading: requestStatusCodes.pending,
};

const getTemplates = createAsyncThunk("templates/getTemplates", async () => {
  const response = axios.get(getTemplatesRoute());
  const { data }: { data: Template } = await response;
  return data;
});

export const templatesSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTemplates.pending, (state) => {
        state.templatesLoading = requestStatusCodes.pending;
      })
      .addCase(getTemplates.fulfilled, (state: Draft<any>, action: PayloadAction<Template>) => {
        state.templatesLoading = requestStatusCodes.fulfilled;
        state.templates = action.payload;
      })
      .addCase(getTemplates.rejected, (state) => {
        state.templatesLoading = requestStatusCodes.rejected;
      });
  },
});

const { reducer } = templatesSlice;

export { reducer, getTemplates };

export default reducer;
